import { TAppNotificationParams } from '@centra/centra-ui'

export const NOTIFICATION_MESSAGES: { [key: string]: { value: string; notification: TAppNotificationParams } } = {
  confirm: {
    value: 'error',
    notification: {
      content: 'Ссылка неправильная или устарела, попробуйте авторизоваться или обратитесь к администратору',
      title: 'Неправильная ссылка',
      view: 'error',
    },
  },
  email: {
    value: 'confirmed',
    notification: {
      content: 'Адрес электронной почты успешно изменен',
      title: 'Успешная операция',
      view: 'success',
    },
  },
}
